export default __webpack_public_path__ + "static/media/map.bf5bb2cd.png";